module.exports = __webpack_public_path__ + "img/banner1.dfac9ad8.jpg";